import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import Reports from "@/Pages/Reports/Expenses/Reports.vue";
import { modalMixins } from "@/mixins/modal.js";
import PayoutModal from "@/components/PayoutModal.vue";
import List from "@/Pages/Reports/Expenses/List.vue";
import Office from "@/Pages/Reports/Expenses/Office.vue";
import Staff from "@/Pages/Reports/Expenses/Staff.vue";
import { ExpenseType } from "@/model-types/expense";
let Index = class Index extends Vue {
    user;
    branchesId;
    dates;
    tabs = Object.freeze([
        { value: 'reports', text: 'Summary' },
        { value: 'salary', text: 'Team members' },
        { value: 'office', text: 'Office expenditures' },
    ]);
    activeTab = this.tabs[0];
    created() {
        this.activeTab = this.tabs[0];
    }
    openModal;
    openPayoutModal() {
        let data = {
            _id: 'temp',
            model: { type: this.activeTab.value === 'salary' ? ExpenseType.salary : ExpenseType.office }
        };
        const { User } = this.$FeathersVuex;
        new User(data);
        this.openModal({ id: 'payoutModal' });
    }
};
__decorate([
    Prop(Array)
], Index.prototype, "user", void 0);
__decorate([
    Prop(Array)
], Index.prototype, "branchesId", void 0);
__decorate([
    Prop(Object)
], Index.prototype, "dates", void 0);
Index = __decorate([
    Component({
        components: { Staff, Office, PayoutModal, Reports, List },
        mixins: [modalMixins],
    })
], Index);
export default Index;
